module.exports = __webpack_public_path__ + "static/media/b.a1023e20.png";